import { BrandsList as BrandsListComponent } from './BrandsList.component';
import { connector } from './BrandsList.connector';

export const BrandsList = connector(BrandsListComponent);
